import React, { useState } from 'react';

const organizations = [
  { id: 1, name: 'Intrust Technologies Pvt. Ltd.', initials: 'IT', color: '#4F46E5', status: 'Active', users: 320, starred: true },
  { id: 2, name: 'ABC Insurance Co.', initials: 'AI', color: '#166534', status: 'Active', users: 256 },
  { id: 3, name: 'XYZ Bank Ltd.', initials: 'XB', color: '#0369A1', status: 'Active', users: 512 },
  { id: 4, name: 'Government of India', initials: 'GI', color: '#EA580C', status: 'Active', users: 1248 },
  { id: 5, name: 'Chola Financial Services', initials: 'CF', color: '#B91C1C', status: 'Active', users: 420 },
  { id: 6, name: 'United India Insurance', initials: 'UI', color: '#0891B2', status: 'Active', users: 278 },
  { id: 7, name: 'HDFC Life Insurance', initials: 'HL', color: '#B91C1C', status: 'Active', users: 310 },
  { id: 8, name: 'TATA Motors Ltd.', initials: 'T', color: '#0369A1', status: 'Trial', users: 150 },
  { id: 9, name: 'Tech Mahindra Ltd.', initials: 'tm', color: '#374151', status: 'Suspended', users: 120 },
  { id: 10, name: 'Mahindra & Mahindra', initials: 'MM', color: '#B91C1C', status: 'Trial', users: 98 },
  { id: 11, name: 'Reliance Industries', initials: 'RI', color: '#92400E', status: 'Active', users: 410 },
  { id: 12, name: 'Bajaj Finserv Ltd.', initials: 'B', color: '#1D4ED8', status: 'Active', users: 198 },
];

const tabs = ['Overview', 'Departments', 'Users', 'Compliance Domains', 'Security', 'Settings'];

const overviewStats = [
  { label: 'Total Users', value: '320', sub: '↑ 12% vs last 30 days', subColor: '#16A34A' },
  { label: 'Departments', value: '8' },
  { label: 'Active Devices', value: '287', sub: '↑ 8%', subColor: '#16A34A' },
  { label: 'Documents Signed', value: '12,456', sub: '↑ 15%', subColor: '#16A34A' },
  { label: 'Storage Used', value: '2.45 TB', sub: 'of 10 TB', progress: 24.5 },
];

const complianceDomains = ['eIDAS', 'GDPR', 'ISO 27001', 'DPDP India', 'SOC 2 Type II', 'HIPAA'];

const securityPosture = [
  { label: 'PQC Enabled', status: 'Enabled' },
  { label: 'HSM Connected', status: 'Healthy' },
  { label: 'Blockchain Anchoring', status: 'Active' },
  { label: 'SSO (SAML)', status: 'Enabled' },
  { label: 'MFA Enforcement', status: 'Enabled' },
];

const recentActivity = [
  { event: 'User Added', desc: 'John Smith was added', user: 'demo.admin@intrust.com', time: 'May 15, 2024 10:25 AM', status: 'Success' },
  { event: 'Document Signed', desc: 'NDA_Agreement.pdf signed', user: 'priya.sharma@intrust.com', time: 'May 15, 2024 09:41 AM', status: 'Success' },
  { event: 'Dept Created', desc: 'IT Security dept created', user: 'demo.admin@intrust.com', time: 'May 14, 2024 08:33 PM', status: 'Success' },
  { event: 'Policy Updated', desc: 'ISO 27001 policy updated', user: 'rohit.verma@intrust.com', time: 'May 14, 2024 04:12 PM', status: 'Success' },
  { event: 'User Deactivated', desc: 'Rahul Mehta deactivated', user: 'demo.admin@intrust.com', time: 'May 14, 2024 03:05 PM', status: 'Warning' },
];

const departments = [
  { name: 'Administration', users: 32 },
  { name: 'IT Security', users: 50 },
  { name: 'Human Resources', users: 28 },
  { name: 'Finance', users: 45 },
  { name: 'Compliance & Legal', users: 30 },
  { name: 'Operations', users: 67 },
  { name: 'Risk Management', users: 29 },
  { name: 'Audit', users: 25 },
];

const orgAdmins = [
  { name: 'Demo Admin', role: 'Super Admin', starred: true },
  { name: 'Priya Sharma', role: 'Admin' },
  { name: 'Rohit Verma', role: 'Admin' },
  { name: 'Sneha Iyer', role: 'Admin' },
];

const quickActions = ['Invite Users', 'Create Department', 'Assign Licenses', 'View Audit Logs', 'Download Org Report'];

const statusColors = {
  Active: { bg: '#DCFCE7', color: '#15803D' },
  Trial: { bg: '#FFEDD5', color: '#C2410C' },
  Suspended: { bg: '#FEE2E2', color: '#B91C1C' },
  Success: { bg: '#DCFCE7', color: '#15803D' },
  Warning: { bg: '#FFEDD5', color: '#C2410C' },
  Healthy: { bg: '#DCFCE7', color: '#15803D' },
  Enabled: { bg: '#DCFCE7', color: '#15803D' },
};

function Badge({ text }) {
  const c = statusColors[text] || { bg: '#F3F4F6', color: '#374151' };
  return (
    <span style={{ display: 'inline-block', fontSize: 10, fontWeight: 600, padding: '1px 6px', borderRadius: 999, background: c.bg, color: c.color, whiteSpace: 'nowrap' }}>
      {text}
    </span>
  );
}

export default function Organizations() {
  const [activeTab, setActiveTab] = useState('Overview');
  const [selectedOrgId, setSelectedOrgId] = useState(1);
  const [search, setSearch] = useState('');

  const selectedOrg = organizations.find((o) => o.id === selectedOrgId) || organizations[0];
  const filteredOrgs = organizations.filter((o) => o.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div style={{
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      display: 'flex',
      height: 'calc(100vh - 96px)',
      overflow: 'hidden',
      margin: '-24px',
      background: '#F1F5F9',
      color: '#111827',
      fontSize: 13,
    }}>

      {/* LEFT PANEL */}
      <div style={{ width: 220, background: '#fff', borderRight: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
        {/* header */}
        <div style={{ padding: '10px 12px 6px', borderBottom: '1px solid #F1F5F9' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
              <span style={{ fontWeight: 700, fontSize: 13 }}>Organizations</span>
              <span style={{ background: '#EEF2FF', color: '#4F46E5', fontSize: 11, fontWeight: 700, padding: '0 6px', borderRadius: 999 }}>{organizations.length}</span>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5, border: '1px solid #E5E7EB', borderRadius: 7, padding: '5px 8px', background: '#F9FAFB' }}>
            <span style={{ color: '#9CA3AF', fontSize: 12 }}>🔍</span>
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search..."
              style={{ border: 'none', outline: 'none', background: 'transparent', fontSize: 12, width: '100%', color: '#111827' }}
            />
          </div>
        </div>
        {/* list */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '4px 8px' }}>
          {filteredOrgs.map((org) => {
            const isSelected = org.id === selectedOrgId;
            return (
              <div
                key={org.id}
                onClick={() => setSelectedOrgId(org.id)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 8, padding: '6px 8px', borderRadius: 8, cursor: 'pointer', marginBottom: 2,
                  background: isSelected ? '#EEF2FF' : 'transparent',
                  border: isSelected ? '1px solid #C7D2FE' : '1px solid transparent',
                }}
              >
                <div style={{ width: 28, height: 28, borderRadius: 7, background: org.color, color: '#fff', fontSize: 11, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  {org.initials || org.name.charAt(0)}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 600, fontSize: 12, color: '#111827', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {org.name}{org.starred && <span style={{ color: '#F59E0B', marginLeft: 3 }}>★</span>}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 2 }}>
                    <Badge text={org.status} />
                    <span style={{ fontSize: 10, color: '#9CA3AF' }}>👤 {org.users}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div style={{ padding: '6px 12px', borderTop: '1px solid #F1F5F9', fontSize: 11, color: '#9CA3AF' }}>
          {filteredOrgs.length} of {organizations.length} organizations
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minWidth: 0 }}>

        {/* org header card */}
        <div style={{ background: '#fff', borderBottom: '1px solid #E5E7EB', padding: '10px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 38, height: 38, borderRadius: 9, background: selectedOrg.color, color: '#fff', fontWeight: 700, fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {selectedOrg.initials || selectedOrg.name.charAt(0)}
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <span style={{ fontWeight: 700, fontSize: 14 }}>{selectedOrg.name}</span>
                <Badge text={selectedOrg.status} />
              </div>
              <div style={{ fontSize: 11, color: '#6B7280' }}>Enterprise Plan · Valid until May 15, 2025</div>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <div>
              <div style={{ fontSize: 10, color: '#9CA3AF' }}>Organization ID</div>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#4F46E5' }}>org_8f7d6e2c1a 📋</div>
            </div>
            <div>
              <div style={{ fontSize: 10, color: '#9CA3AF' }}>Default Domain</div>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#4F46E5' }}>intrust.com 📋</div>
            </div>
            <button style={{ border: '1px solid #E5E7EB', background: '#fff', borderRadius: 7, width: 30, height: 30, cursor: 'pointer', fontSize: 16, color: '#6B7280' }}>⋯</button>
          </div>
        </div>

        {/* tabs */}
        <div style={{ display: 'flex', gap: 0, borderBottom: '1px solid #E5E7EB', background: '#fff', paddingLeft: 16, flexShrink: 0 }}>
          {tabs.map((tab) => (
            <div key={tab} onClick={() => setActiveTab(tab)} style={{
              cursor: 'pointer', padding: '8px 14px', fontSize: 12,
              fontWeight: activeTab === tab ? 700 : 500,
              color: activeTab === tab ? '#4F46E5' : '#6B7280',
              borderBottom: activeTab === tab ? '2px solid #4F46E5' : '2px solid transparent',
            }}>
              {tab}
            </div>
          ))}
        </div>

        {/* scrollable body */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: 10 }}>

          {/* stat cards */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 8 }}>
            {overviewStats.map((stat) => (
              <div key={stat.label} style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: 10, padding: '10px 12px' }}>
                <div style={{ fontSize: 11, color: '#6B7280', marginBottom: 4 }}>{stat.label}</div>
                <div style={{ fontSize: 18, fontWeight: 700 }}>{stat.value}</div>
                {stat.sub && <div style={{ fontSize: 10, color: stat.subColor || '#9CA3AF', marginTop: 2 }}>{stat.sub}</div>}
                {stat.progress !== undefined && (
                  <div style={{ marginTop: 6 }}>
                    <div style={{ height: 4, background: '#F1F5F9', borderRadius: 999 }}>
                      <div style={{ width: `${stat.progress}%`, height: '100%', background: '#4F46E5', borderRadius: 999 }} />
                    </div>
                    <div style={{ fontSize: 10, color: '#9CA3AF', marginTop: 2, textAlign: 'right' }}>{stat.progress}%</div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* 3 columns */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8 }}>

            {/* Compliance */}
            <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: 10, padding: '10px 12px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                <span style={{ fontWeight: 700, fontSize: 12 }}>Compliance Domains</span>
                <span style={{ fontSize: 11, color: '#4F46E5', fontWeight: 600, cursor: 'pointer' }}>Manage</span>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                {complianceDomains.map((d) => (
                  <span key={d} style={{ background: '#EEF2FF', color: '#4F46E5', fontSize: 11, fontWeight: 600, padding: '3px 8px', borderRadius: 6 }}>{d}</span>
                ))}
              </div>
            </div>

            {/* Security */}
            <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: 10, padding: '10px 12px' }}>
              <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 8 }}>Security Posture</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {securityPosture.map((s) => (
                  <div key={s.label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: 12, color: '#374151' }}>🔒 {s.label}</span>
                    <Badge text={s.status} />
                  </div>
                ))}
              </div>
              <div style={{ fontSize: 11, color: '#4F46E5', fontWeight: 600, marginTop: 8, cursor: 'pointer' }}>View Security Settings →</div>
            </div>

            {/* Subscription */}
            <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: 10, padding: '10px 12px' }}>
              <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 8 }}>Subscription &amp; Usage</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, fontSize: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ color: '#6B7280' }}>Plan</span><span style={{ fontWeight: 600 }}>Enterprise</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ color: '#6B7280' }}>Valid Until</span><span style={{ fontWeight: 600 }}>May 15, 2025</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ color: '#6B7280' }}>Licensed Users</span><span style={{ fontWeight: 600 }}>500</span></div>
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 3 }}><span style={{ color: '#6B7280' }}>Storage</span><span style={{ fontWeight: 600 }}>2.45 / 10 TB</span></div>
                  <div style={{ height: 4, background: '#F1F5F9', borderRadius: 999 }}><div style={{ width: '24.5%', height: '100%', background: '#4F46E5', borderRadius: 999 }} /></div>
                </div>
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 3 }}><span style={{ color: '#6B7280' }}>API Calls</span><span style={{ fontWeight: 600 }}>2.45 / 10 M</span></div>
                  <div style={{ height: 4, background: '#F1F5F9', borderRadius: 999 }}><div style={{ width: '24.5%', height: '100%', background: '#4F46E5', borderRadius: 999 }} /></div>
                </div>
              </div>
              <div style={{ fontSize: 11, color: '#4F46E5', fontWeight: 600, marginTop: 8, cursor: 'pointer' }}>Manage Subscription →</div>
            </div>
          </div>

          {/* Recent activity */}
          <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: 10, padding: '10px 12px' }}>
            <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 8 }}>Recent Activity</div>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
              <thead>
                <tr style={{ textAlign: 'left', color: '#9CA3AF', fontSize: 11 }}>
                  <th style={{ padding: '4px 6px', fontWeight: 600 }}>Event</th>
                  <th style={{ padding: '4px 6px', fontWeight: 600 }}>Description</th>
                  <th style={{ padding: '4px 6px', fontWeight: 600 }}>User</th>
                  <th style={{ padding: '4px 6px', fontWeight: 600 }}>Time</th>
                  <th style={{ padding: '4px 6px', fontWeight: 600 }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {recentActivity.map((row) => (
                  <tr key={`${row.event}-${row.time}`} style={{ borderTop: '1px solid #F1F5F9' }}>
                    <td style={{ padding: '6px 6px', fontWeight: 600, whiteSpace: 'nowrap' }}>
                      <span style={{ display: 'inline-block', width: 7, height: 7, borderRadius: '50%', background: row.status === 'Success' ? '#22C55E' : '#F59E0B', marginRight: 6 }} />
                      {row.event}
                    </td>
                    <td style={{ padding: '6px 6px', color: '#374151' }}>{row.desc}</td>
                    <td style={{ padding: '6px 6px', color: '#6B7280' }}>{row.user}</td>
                    <td style={{ padding: '6px 6px', color: '#6B7280', whiteSpace: 'nowrap' }}>{row.time}</td>
                    <td style={{ padding: '6px 6px' }}><Badge text={row.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{ fontSize: 11, color: '#4F46E5', fontWeight: 600, marginTop: 8, cursor: 'pointer' }}>View All Activity →</div>
          </div>

        </div>
      </div>

      {/* RIGHT PANEL */}
      <div style={{ width: 210, borderLeft: '1px solid #E5E7EB', background: '#fff', display: 'flex', flexDirection: 'column', overflow: 'hidden', flexShrink: 0 }}>
        <div style={{ padding: '10px 12px', borderBottom: '1px solid #F1F5F9' }}>
          <button style={{ width: '100%', background: '#4F46E5', color: '#fff', border: 'none', borderRadius: 7, padding: '7px 0', fontWeight: 600, fontSize: 12, cursor: 'pointer' }}>
            + New Organization
          </button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: 12 }}>

          {/* Departments */}
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <span style={{ fontWeight: 700, fontSize: 12 }}>Departments ({departments.length})</span>
              <span style={{ fontSize: 11, color: '#4F46E5', fontWeight: 600, cursor: 'pointer' }}>+ Add</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
              {departments.map((d) => (
                <div key={d.name} style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                  <div style={{ width: 26, height: 26, borderRadius: 7, background: '#F3F4F6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, flexShrink: 0 }}>👤</div>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 600 }}>{d.name}</div>
                    <div style={{ fontSize: 10, color: '#9CA3AF' }}>{d.users} Users</div>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ fontSize: 11, color: '#4F46E5', fontWeight: 600, marginTop: 6, cursor: 'pointer' }}>View all →</div>
          </div>

          <div style={{ borderTop: '1px solid #F1F5F9' }} />

          {/* Admins */}
          <div>
            <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 6 }}>Administrators ({orgAdmins.length})</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
              {orgAdmins.map((a, i) => (
                <div key={a.name} style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                  <div style={{ width: 26, height: 26, borderRadius: 7, background: '#F3F4F6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, flexShrink: 0 }}>👤</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 12, fontWeight: 600 }}>{a.name}{a.starred && <span style={{ color: '#F59E0B', marginLeft: 3 }}>★</span>}</div>
                    <div style={{ fontSize: 10, color: '#9CA3AF' }}>{a.role}</div>
                  </div>
                  {i === orgAdmins.length - 1 && (
                    <span style={{ fontSize: 10, fontWeight: 600, background: '#F3F4F6', color: '#374151', padding: '2px 6px', borderRadius: 999 }}>+1</span>
                  )}
                </div>
              ))}
            </div>
            <div style={{ fontSize: 11, color: '#4F46E5', fontWeight: 600, marginTop: 6, cursor: 'pointer' }}>View all →</div>
          </div>

          <div style={{ borderTop: '1px solid #F1F5F9' }} />

          {/* Quick actions */}
          <div>
            <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 6 }}>Quick Actions</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
              {quickActions.map((action) => (
                <div key={action} style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12, color: '#374151', cursor: 'pointer' }}>
                  <span style={{ color: '#4F46E5' }}>▸</span>{action}
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}